function getInstagramCarousel() {
  var states = [
    [0, 1, 2],
    [1, 2, 0],
    [2, 0, 1]
  ];
  var currentState = 0;

  var $carouselContainer = $('.instagram-slider-nav');
  var $carousel = $('.instagram-slider-inner');
  var $items = $carousel.find('.instagram-slider-item');
  var $navItems = $('.instagram-nav-item', $carouselContainer);

  function setState(state) {
    currentState = state;
    var stateItems = states[currentState];

    $items.each(function(i) {
       $('.instagram-slider-item', $carousel).removeClass('pos-' + (i+1));
        $('.item-' + (stateItems[i] + 1), $carousel).addClass('pos-' + i);
    });
    $navItems.removeClass("active").eq(currentState).addClass("active");
  }


  // Set up the swipe actions
  var start = null;
  var current = null;
  var isDragging = false;
  var threshold = 100;
  var direction = null;

  $carousel.on("touchstart mousedown", function(e) {
    start = e.pageX || e.originalEvent.touches[0].pageX;
    isDragging = true;
  });

  $(document).on("touchmove mousemove", function(e) {
    if (!isDragging) {
      return;
    }
    current = e.pageX || e.originalEvent.touches[0].pageX;
  });

  $(document).on("touchend mouseup", function(e) {
    if (!isDragging) {
      return;
    }
    isDragging = false;
    var distance = current ? current - start : 0;
    if (Math.abs(distance) >= threshold) {
      direction = distance > 0 ? "right" : "left";
      var directionState = (currentState + (direction === "left" ? 1 : 2)) % 3;
      setState(directionState);
    }
    
  });
  
  $navItems.click(function() {
    var index = $(this).index();
    if (index === currentState) return;
    setState(index);
  });

};